import {UserState} from '~/stores/crmStateStore';

export default defineNuxtRouteMiddleware(async (to) => {
	const {fetchAuthStatus, isAuthenticated} = useAuth();

	await fetchAuthStatus({force: true});

	const pageToStatehMapping: Partial<Record<string, UserState>> = {
		'muj-ucet': UserState.LOGIN_MY_ACCOUNT,
		'muj-ucet-kupony': UserState.LOGIN_COUPONS,
		'muj-ucet-kupony-kupon-id': UserState.LOGIN_COUPON_DETAIL,
		'muj-ucet-kupony-odmena-id': UserState.LOGIN_GIFT_DETAIL,
		'muj-ucet-nastaveni-uctu': UserState.LOGIN_ACCOUNT_SETTINGS,
		'muj-ucet-penezni-bonus': UserState.LOGIN_CASH_BONUS,
		'muj-ucet-prehled-uctenek': UserState.LOGIN_RECEIPTS,
	};

	if (!isAuthenticated.value) {
		const query = {
			state: pageToStatehMapping[String(to.name)] || UserState.LOGIN_MY_ACCOUNT,
			...(to.hash && {redirectHash: to.hash}),
		};

		return navigateTo({name: 'prihlaseni', query}, {redirectCode: 302});
	}
});
